<template>
  <div class="auth-form">
    <template v-if="isUser">
      <h3>Завершення реєстрації</h3>
      <p>Вкажіть ім’я та прізвище, щоб створити профіль мешканця.</p>
      <auth-form-register />
    </template>
    <b-tabs v-else content-class="mt-3" fill pills>
      <b-tab title="Вхід" active>
        <auth-form-login />
      </b-tab>
      <b-tab title="Реєстрація">
        <auth-form-register />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AuthFormLogin from "./auth-form-login.vue";
import AuthFormRegister from "./auth-form-register.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    AuthFormLogin,
    AuthFormRegister,
  },
  computed: mapGetters(["isUser"]),
};
</script>

<style lang="scss" scoped>
.auth-form {
}
</style>
